import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'kangarootime-ui';
import { graphql, compose } from 'react-apollo';
import { GET_ALL_CHANNELS_AT_CENTER_AS_MANAGER, GET_DIRECT_MESSAGEABLE_PARENTS, GET_DIRECT_MESSAGEABLE_EMPLOYEES } from '../../graphql/queries';
import NavigationBars from '../../../../components/HOC/withNavigationBars';
import RaisedContainer from '../../../../components/RaisedContainer';
import SearchFilters from './SearchFilters';
import MessagesTable from './MessagesTable';
import actions from '../../ducks/actions';
import moment from 'moment';

class ManagerMessagesOverview extends Component {
  componentDidMount = () => {
    // when the page mounts perform a query of the center if there aren't any messages already fetched
    if (this.props.queriedMessages.length === 0) {
      this.props.performSearchQuery({
        channelIds: [],
        senderId: '',
        startDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      });
    }
  }

  get breadcrumbs () {
    return [
      { label: 'Messages', link: null },
      { label: 'Manager Overview', link: null }
    ];
  }

  canLoadMoreMessages = () => {
    const { nextTokens } = this.props;

    if (Object.keys(nextTokens).length) {
      return Object.values(nextTokens).some(v => Boolean(v));
    }

    return false;
  }

  render () {
    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <RaisedContainer style={{ height: '80vh' }}>
            <SearchFilters
              channels={this.props.channels.getAllChannelsAtCenterAsManager || []}
              performSearchQuery={this.props.performSearchQuery}
              users={{
                parents: this.props.parents.getDirectMessageableParentsAsEmployee || [],
                employees: this.props.employees.getChannelMessageableUsers || []
              }}
              fetchingUsers={this.props.parents.loading || this.props.employees.loading}
              fetchingChannels={this.props.channels.loading}
              currentQuery={this.props.currentQuery}
              performingQuery={this.props.performingQuery}
            />
            <MessagesTable
              messages={this.props.queriedMessages}
              showLoadMore={this.canLoadMoreMessages()}
              loadMoresMessagesUsingExistingQuery={() => this.props.performSearchQuery(null)}
              performingNewQuery={this.props.performingQuery && this.props.queriedMessages.length === 0}
              loadingMoreFromExistingQuery={this.props.performingQuery && this.props.queriedMessages.length > 0}
            />
          </RaisedContainer>
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    currentCenterId: state.identity.centerId,
    queriedMessages: state.messages.managerOverview.messages,
    nextTokens: state.messages.managerOverview.nextTokens,
    performingQuery: state.messages.managerOverview.performingQuery,
    currentQuery: state.messages.managerOverview.currentQuery
  };
}

function mapDispatchToProps (dispatch) {
  return {
    performSearchQuery: query => dispatch(actions.managerMessagesOverviewQuery(query))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(compose(
  graphql(GET_ALL_CHANNELS_AT_CENTER_AS_MANAGER, {
    name: 'channels',
    options: props => ({
      fetchPolicy: 'cache-and-network',
      variables: {
        centerId: props.currentCenterId
      }
    })
  }),
  graphql(GET_DIRECT_MESSAGEABLE_EMPLOYEES, {
    name: 'employees',
    options: props => ({
      fetchPolicy: 'cache-first',
      variables: {
        centerId: props.currentCenterId
      }
    })
  }),
  graphql(GET_DIRECT_MESSAGEABLE_PARENTS, {
    name: 'parents',
    options: props => ({
      fetchPolicy: 'cache-first',
      variables: {
        centerId: props.currentCenterId
      }
    })
  })
)(ManagerMessagesOverview));
